import styled from 'styled-components';

const LoginWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .card {
    background: #ffffff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 35px;
  }

  .merchant-contract {
    margin-top: 20px;
  }

  .form-title {
    max-width: 320px;
    text-align: center;
    font-size: 30px;
    color: #757575;
    letter-spacing: 0.56px;
    line-height: 30px;
    padding-bottom: 48px;
    white-space: pre-wrap;
  }

  .error-message {
    max-width: 320px;
    font-size: 14px;
    padding-bottom: 14px;
    color: #d14641;
    letter-spacing: 0.17px;
  }

  .error {
    font-size: 14px;
    color: #d14641;
    letter-spacing: 0.17px;
  }

  .form-group {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: 15px;
    .clear,
    .see {
      position: absolute;
      right: 0;
      padding-right: 10px;
      cursor: pointer;
    }
    .clear {
      font-size: 22px;
      color: #a1a1a1;
      height: 32px;
    }
    .clear-see {
      right: 20px;
    }

    label {
      transition: all 0.3s ease;
      display: inline-block;
      margin-bottom: 2px;
      font-size: 16px;
      color: #a1a1a1;
      letter-spacing: 0.26px;
    }

    input {
      font-size: 14px;
      color: #757575;
      letter-spacing: 0.3px;
      border-left: none;
      border-top: none;
      border-right: none;
      display: block;
      width: 100%;
      outline: none;

      &:focus {
        outline: none;
        border-bottom: 2px solid #2d8cf0;

        + label {
          color: #2d8cf0;
        }
      }
    }

    input.error {
      border-bottom: 2px solid #d23b3b;
      box-shadow: inset 0px -5px 9px -10px #d23b3b !important;
      box-shadow: 0px 8px 9px -10px #d23b3b;
    }
  }
`;

export { LoginWrapper };
